import { consentDisabled } from '../consent';
import { ConsentWatcher, IOneTrustBase, OneTrustConfig, OneTrustConsent } from '../types';

export class OneTrustDisabled implements IOneTrustBase {
    init(_config?: OneTrustConfig): Promise<unknown> {
        return Promise.resolve();
    }

    showPreferenceModal(): void {
        // no op
    }

    getConsentStatus(): Promise<OneTrustConsent> {
        return Promise.resolve(consentDisabled);
    }

    watchConsentStatus(_callback: ConsentWatcher): () => void {
        return () => {};
    }
}
